import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [favoriteIds, setFavoriteIds] = useState(new Set());

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("ember_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
      const favRes = await api.get("/favorites/ids");
      setFavoriteIds(new Set(favRes.data.ids || []));
    } catch (e) {
      localStorage.removeItem("ember_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });
    localStorage.setItem("ember_token", res.data.token);
    setUser(res.data.user);
    const favRes = await api.get("/favorites/ids");
    setFavoriteIds(new Set(favRes.data.ids || []));
    return res.data.user;
  };

  const register = async (email, password, display_name) => {
    const res = await api.post("/auth/register", { email, password, display_name });
    localStorage.setItem("ember_token", res.data.token);
    setUser(res.data.user);
    setFavoriteIds(new Set());
    return res.data.user;
  };

  const logout = () => {
    localStorage.removeItem("ember_token");
    setUser(null);
    setFavoriteIds(new Set());
  };

  const toggleFavorite = async (recipeId) => {
    if (!user) return false;
    const isFav = favoriteIds.has(recipeId);
    const next = new Set(favoriteIds);
    if (isFav) {
      await api.delete(`/favorites/${recipeId}`);
      next.delete(recipeId);
    } else {
      await api.post(`/favorites/${recipeId}`);
      next.add(recipeId);
    }
    setFavoriteIds(next);
    return !isFav;
  };

  return (
    <AuthContext.Provider
      value={{ user, loading, login, register, logout, favoriteIds, toggleFavorite }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
